module.exports = __webpack_public_path__ + "img/currency1.af991e3e.png";